<template>
  <div>
    <b-card-body>
      <b-row
        v-for="(brand,index) in dataList"
        :key="brand.id"
      >
        <b-col
          v-if="index > 0"
          cols="12"
          class="mt-2"
        >
          <hr>
        </b-col>
        <b-col
          cols="12"
          class="mb-2"
        >
          <primary-heading
            :title-text="brand.title"
            title-class="text-danger"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="border-right mb-1"
        >
          <flat-card
            title="Satışlar"
            :value="brand.sales"
            color="success"
            icon="CheckCircleIcon"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="border-right mb-1"
        >
          <flat-card
            title="Bağlantılar"
            :value="brand.connections"
            color="info"
            icon="LinkIcon"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <flat-card
            title="Stoklar"
            :value="brand.stocks"
            color="warning"
            icon="CodesandboxIcon"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </div>
</template>
<script>
import { BCol, BRow, BCardBody } from 'bootstrap-vue'
import PrimaryHeading from '@/layouts/components/PrimaryHeading.vue'
import FlatCard from '@/layouts/components/ReportCards/FlatCard.vue'

export default {
  name: 'ListCards',
  components: {
    BCol,
    BRow,
    BCardBody,
    PrimaryHeading,
    FlatCard,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
}
</script>
